module.exports = __webpack_public_path__ + "img/canada-leukaemia-male.710f811d.png";